<template>
<!--头部-->
  <div class="headerMain">
    <div style="line-height: 40px;display: flex">
      {{router_title}}
    </div>
    <div class="rightBox">
      <el-dropdown @command="getItem" @visible-change="changeArrow">
        <span class="el-dropdown-link" style="cursor: pointer">
          <div v-if="emptyImg" style="display: inline-block;background:#E95646" class="emptyAdmin">
            <img src="../assets/avatar@2x.png" alt="">
          </div>
        <div  v-if="!emptyImg"  style="display: inline-block">
          <img :src="adminUrl" alt="" @load="loadingImg()">
        </div>
        <div class="loadImg" v-if="adminImg">
          <i class="el-icon-loading"></i>
        </div>
        <div style="display: inline-block" :class="emptyImg?'changePositions':''">
          <i class="el-icon-arrow-down el-icon--right" v-if="arrow"></i>
          <i class="el-icon-arrow-up el-icon--right" v-if="!arrow"></i>
        </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">Profile</el-dropdown-item>
          <el-dropdown-item command="b">Change Password</el-dropdown-item>
          <el-dropdown-item divided command="c">
            <i class="el-icon-switch-button"></i>Log out</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--    profile弹框-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Profile"
      :visible.sync="changeProfile"
      width="40%">
      <!--      <h1 style="color: #E95646;text-align: left">Chase Auto Parts</h1>-->
      <div style="text-align: left;font-weight: normal"  v-loading="profileLoading">
        <el-form :model="profileForm" label-position="top" :rules="rules2" status-icon ref="ruleForm" :show-message="false">
          <el-form-item label="Avatar" label-width="120px">
            <div class="avater">
              <vue-hover-mask>
                <!-- 默认插槽 -->
                <div v-if="emptyImg" style="background:#E95646" class="emptyAvatar">
                  <img src="../assets/avatar@2x.png" alt="">
                </div>
                <img v-if="!emptyImg" :src="imageUrl" class="avatar" @load="changeImg">
                <div class="avatarLoad" v-if="imageLoading">
                  <i class="el-icon-loading"></i>
                </div>
                <!-- action插槽 -->
                <template v-slot:action>
                  <el-dropdown trigger="click" @command="deleteImg" placement="bottom">
                  <span class="el-dropdown-link">
                  <i class="el-icon-camera" style="color: #F5F6FB;font-size: 24px" v-if="!imageLoading"></i>
                  </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-upload
                        class="avatar-uploader"
                        :action="actionUrl"
                        :headers="config"
                        :http-request="httpRequest"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                      >
                        <el-dropdown-item command="a">Upload a photo</el-dropdown-item>
                      </el-upload>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </vue-hover-mask>
            </div>
          </el-form-item>
          <el-form-item label="Username" label-width="120px" required>
            <el-input v-model="user_name"  placeholder="" autocomplete="off" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button plain @click="saveChange" >Cancel</el-button>
        <el-button type="success" @click="cancelChange" round style="width: 80px;padding: 0">Save</el-button>
  </span>
    </el-dialog>
    <!--change password 弹框-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Change Password"
      :visible.sync="changePasswordDialog"
      width="30%">
      <div style="text-align: left;font-weight: normal">
        <el-form :model="passwordForm" label-position="top" :rules="rules" status-icon ref="ruleForms" :show-message="false">
          <el-form-item label="Current Password" label-width="120px" prop="curPassword" >
            <el-input v-model="passwordForm.curPassword"  placeholder="Current Password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label=" New Password" label-width="120px" required>
            <div class="middleText">
              At least 8 characters, with one or more uppercase letters, lowercase letters, numbers
            </div>
            <change-pass ref="changePassForm"></change-pass>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button plain @click="closeChangeDialog" >Cancel</el-button>
        <el-button type="success" @click="saveChangePass" round style="width: 80px;padding: 0">Save</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import VueHoverMask from 'vue-hover-mask'
import {Axios} from "@/axios/axios";
import {updateAdmin,updatePassword} from "@/api/login";
import changePass from "@/components/changePass";
export default {
  components:{
    VueHoverMask,changePass
  },
  data(){
    return{
      router_title:"",
      arrow:true,
      emptyImg:true,
      adminUrl:'',
      adminImg:false,
      profileLoading:false,
      changeProfile:false,
      changePasswordDialog:false,
      profileForm:{
        hubName:'',
        address:'',
      },
      imageUrl:"",
      passwordForm:{
        curPassword:'',
        newPassword:"",
      },
      rules:{
        curPassword: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      rules2:{
        hubName: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      imageLoading: true,
      actionUrl: process.env.VUE_APP_BASE_URL,
      user_name:''
    }
  },
  computed: {
    config() {
      return { token: this.token };
    },
  },
  created() {
    this.router_title = this.$route.meta.title
    let arvater = JSON.parse(localStorage.getItem('userInfoDetail')).avatar ;
    this.imageUrl =  arvater
    this.adminUrl = arvater
    if (this.imageUrl){
      this.emptyImg = false
    }
    console.log(this.imageUrl,this.emptyImg,'arvater')
  },
  watch:{
    $route:{
      handler(val,oldval){
        this.router_title = val.meta.title
        }
      },
      // 深度观察监听
      deep: true
    },
  methods:{
    closeChangeDialog(){
      this.changePasswordDialog = false
      this.$refs.ruleForms.resetFields();
      this.$refs.changePassForm.validateClear()
    },
    validateForm() {
      let flag = false
      this.$refs['ruleForms'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    saveChangePass(){
      this.validateForm()
      this.$refs.changePassForm.validateForm()
      let test =  new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$")
      let cp1 = this.$refs.changePassForm.passwordForm
      if (this.validateForm() && this.$refs.changePassForm.validateForm()){
        // console.log(test.test(this.passwordForm.curPassword),'sss')
        if (!test.test(this.passwordForm.curPassword)) {
          this.$message({
            message: 'Current Password  is invalid',
            type: 'error'
          });
        } else if (!test.test(cp1.curPass)) {
          this.$message({
            message: 'Password must be At least 8 characters, with one or more uppercase letters, lowercase letters, numbers',
            type: 'error'
          });
        } else if (cp1.curPass != cp1.newPass) {
          this.$message({
            message: 'The new passwords do not match.',
            type: 'error'
          });
        }else {
          // 调接口修改密码
          updatePassword({
            current_password:this.passwordForm.curPassword,
            new_password:cp1.newPass,
          }).then(res=>{
            if (res.code == 200){
              this.$message({
                message:res.msg ,
                type: 'success'
              });
              localStorage.removeItem('token');
              localStorage.removeItem('userInfo');
              setTimeout(() => {
                this.$router.push({ path: '/login' });
              });
            }else {
              this.$message({
                message:res.msg ,
                type: 'error'
              });
            }
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'error'
            });
          })
        }
      }else {
      }
    },
    cancelChange(){
      this.changeProfile = false
    },
    saveChange(){
      this.changeProfile = false
    },
    httpRequest(data) {
      let _this = this;
      let file = data.file;
      let formData = new FormData();
      formData.append('file', file);

      // 如果需要传递其他字段，可以继续添加
      // formData.append('fieldName', 'fieldValue');

      // 发送请求
      Axios.post('/adminapi/uploadAvatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "token":localStorage.getItem('token')
        }
      })
        .then(response => {
          // 处理响应
          if (response.code === 200) {
            if (_this.emptyImg) {
              _this.emptyImg = false;
            }
            console.log('response.data',response.data)
            _this.imageUrl = _this.actionUrl + response.data.data.url;
            _this.adminUrl = _this.actionUrl + response.data.data.url;
            updateAdmin({
              avatar:_this.imageUrl
            }).then(res=>{
              if (res.code !== 200) {
                this.$message.error(res.msg);
              }
            })
            _this.$message({
              message: 'Photo has been uploaded',
              type: 'success'
            });
          } else {
            _this.$message({
              message: response.data.msg,
              type: 'warning'
            });
          }
        })
        .catch(error => {
          console.error('Error uploading file:', error);
        });
    },
    handleAvatarSuccess(res, file){
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    //改变箭头
    changeArrow(i){
      if (i == true){
        this.arrow = false
      }else {
        this.arrow = true
      }
    },
    //图片加载
    loadingImg(){
      this.adminImg = false
    },
    changeImg(){
      this.imageLoading = false
    },
    //删除照片
    deleteImg(i){
    },
    getItem(command){
      if (command == 'a'){
        this.changeProfile = true
        this.imageLoading = false
        // this.profileLoading = true
        let user_name = JSON.parse(localStorage.getItem('userInfoDetail')).username
        this.user_name = user_name
      }else if (command == 'b'){
        this.changePasswordDialog = true
      }else if (command == 'c'){
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo');
        this.$router.push('/login')
      }
    },

  }
}
</script>

<style scoped lang="less">
.headerMain{
  font-weight: bold;
  font-size: 16px;
  padding: 16px 0px;
  display: flex;
  justify-content: space-between;
  /deep/.el-dialog__header{
    padding-bottom: 0;
  }

  .leftSelect{
    display: flex;
    div{
      cursor: pointer;
    }
    .innerLeft{
      margin-right: 16px;
    }
    /deep/.el-select-dropdown__item{
      min-width: 170px;
    }

  }
  .rightSelete{
    display: flex;
    padding-left: 24px;
    /deep/.el-input__inner{
      background: none;
      border: none;
      font-size: 14px;
      font-family: SFPro-Bold, SFPro;
      font-weight: bold;
      color: #000000;
      line-height: 20px;
    }

  }
  .rightBox{
    .changePositions{
      transform: translateY(-80%);
      margin-left: 8px;
    }
    .emptyAdmin{
      width: 40px;
      height: 40px;
      border-radius: 8px;
      position: relative;
      img{
        width: 20px;
        height: 20px;
        //border-radius: 5px;
        //margin-right: 8px;
        //position: relative;
        //width: 20px;
        //height: 20px;
        //margin: 0 auto;
        position: absolute;
        top: 25%;
        left: 25%;
      }

    }
    img{
      width: 40px;
      height: 40px;
      border-radius: 5px;
      vertical-align: middle;
      margin-right: 8px;
      position: relative;
    }
    font-size: 14px;
    .loadImg{
      position: absolute;
      top: 0;
      width: 40px;
      height: 40px;
      background: rgba(0,0,0,0.6);
      border-radius: 5px;
      i{
        margin-top: 10px;
        color: #FFFFFF;
      }
    }
  }
  .middleText{
    font-size: 12px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color: #1F2D42;
    line-height: 20px;
  }
  .avater{
    .emptyAvatar{
      width: 80px;
      height: 80px;
      text-align: center;
      position: relative;
      img{
        width: 40px;
        height: 40px;
        margin: 0 auto;
        position: absolute;
        top: 25%;
        left: 25%;
      }
    }
    img{
      width: 80px;
      height: 80px;
      border-radius: 8px;
    }

  }
  .avatarLoad{
    position: absolute;
    top: 0;
    width: 80px;
    height: 80px;
    background: rgba(0,0,0,0.6);
    border-radius: 5px;
    text-align: center;
    i{
      margin-top: 25px;
      color: #FFFFFF;
      font-size: 30px;
    }
  }

}
.changePosition{
  margin-top: 0px!important;
}

.addnewBox{
  padding-right: 10px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: right;
}
</style>
